import ng from 'angular';
import { UiLanguageSwitchConst } from '@/configuration';

export class OrganNewSubAccountUserController {
    public static $inject: string[] = ['$translate'];

    public newUser: any;
    public newSubAccount: any;
    public password: string;
    public languageDropdownItems: { name: string; value: string }[] = [];

    constructor(
        private $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit() {
        for (const languageIso in UiLanguageSwitchConst) {
            // eslint-disable-next-line no-prototype-builtins
            if (UiLanguageSwitchConst.hasOwnProperty(languageIso)) {
                this.languageDropdownItems.push(
                    {
                        name: this.$translate.instant(UiLanguageSwitchConst[languageIso].translationId),
                        value: languageIso
                    }
                );
            }
        }
    }

    public setEmailAdress = (email) => {
        // Also set email address for the account
        if ([undefined, null].indexOf(this.newSubAccount) < 0) {
            this.newSubAccount.emailAddress = email;
        }
    };

    public languageSelected = (language) => {
        // Also set the language for the account
        if ([undefined, null].indexOf(this.newSubAccount) < 0) {
            this.newSubAccount.language = language;
        }
    };

}

export class OrganNewSubAccountUserComponent implements ng.IComponentOptions {
    public bindings = {
        newSubAccount: '=',
        newUser: '=',
        password: '='
    };
    public template = require('./sub-account-user.html');
    public controller = OrganNewSubAccountUserController;
}
